import { PaymentCardErrorMap } from './interfaces/card.interface';

export const PAYMENT_ERROR_MESSAGES: PaymentCardErrorMap = {
  required: 'Cannot be empty',
  expired: 'The card is expired',
  invalidMonth: 'Month must be 01-12',
  maxlength: 'Input is too long',
  invalidCardNumber: 'Invalid card number',
  invalidDate: 'Invalid date',
  invalidCVV: 'Invalid CCV',
  invalidCardHolder: 'Invalid cardholder name',
} as const;

export const CVV_HINT_CONFIG = {
  x: 'before' as const,
  y: 'above' as const,
  overlap: false,
  backdrop: true,
} as const;
